import React, { Component } from "react";

// slideshow module
import Slider from "react-slick";
// styles for page
import "./reg_step1.css";
// navigation arrows
import { NavigationArrow, edit } from "../other components/navigation_arrow";
import { Saved } from "../other components/savedAlert";
// icons for page
import Ionicon from "react-ionicons";
// request module
import axios from "axios";
// cropper module
import "cropperjs/dist/cropper.css";
import Cropper from "react-cropper";
// draggable module
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove
} from "react-sortable-hoc";

// draggable module components //start
const DragHandle = SortableHandle(() => (
  <Ionicon
    icon="ios-move"
    color="white"
    fontSize="45px"
    className="layerIcon mv"
  />
));
const SortableItem = SortableElement(({ value }) => (
  <li className="relativeItem">
    <div className="alphaLayer">
      <div className="layerRow ">
        <DragHandle />
        <Ionicon
          icon="ios-close"
          color="white"
          fontSize="60px"
          className="layerIcon cl"
        />
      </div>
      <div className="layerRow">
        <Ionicon
          icon="ios-sync"
          color="white"
          fontSize="55px"
          className="layerIcon rot"
        />
        <Ionicon
          icon="ios-crop"
          color="white"
          fontSize="55px"
          className="layerIcon cr"
        />
      </div>
    </div>
    <img src={value} />
  </li>
));

const SortableList = SortableContainer(({ items }) => {
  return (
    <ul className="uploadedSlides">
      {items.map((value, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          value={value}
          useDragHandle={true}
        />
      ))}
    </ul>
  );
});
// draggable module components //end

export default class RegStep1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logo: null,
      productPhoto1: null,
      title: null,
      titleInitial: `CLICK HERE\nTO TYPE\nTHE MAIN TITLE`,
      attractiveText: null,
      attractiveTextInitial: `CLICK HERE TO TYPE\nAN ATTRACTIVE TEXT `,
      description: null,
      descriptionInitial: `Type here some short description. Can be several lines\n150 symbol tops.`,
      buttonValue: null,
      buttonValueInitial: "LEARN MORE",
      // editor and slideshow
      slideshow: [],
      editorOpen: false,
      activeImg: null,
      saved: false,
      //
      history: {
        // field history and current index
        logo: [null],
        logoIndex: 0,
        //
        productPhoto1: [null],
        productPhoto1Index: 0,
        //
        title: [null],
        titleIndex: 0,
        //
        attractiveText: [null],
        attractiveTextIndex: 0,
        //
        description: [null],
        descriptionIndex: 0,
        //
        buttonValue: [null],
        buttonValueIndex: 0,
        // last modified element
        lastModifiedElement: [null],
        lastModifiedElementIndex: 0
      }
    };
    // undo/redo step
    this.actionStep = 1;
  }
  actionUndo = command => {
    // document.execCommand(command, false, null);
    // clone history object
    let history = this.state.history;
    let lastElementKey = history.lastModifiedElementIndex;
    let action = history.lastModifiedElement[lastElementKey];

    let key = null;
    let value = null;
    if (
      action &&
      history[`${action}Index`] <= history[action].length &&
      lastElementKey > 0
    ) {
      console.log(history[action].length);
      if (command === "undo") {
        history.lastModifiedElementIndex = history.lastModifiedElementIndex - 1;
        // get action by lastmodified element  index
        //  undo step /3
        history[`${action}Index`] = history[`${action}Index`] - this.actionStep;
      }
      if (command === "redo") {
        history.lastModifiedElementIndex = history.lastModifiedElementIndex + 1;
        //  undo step /3
        history[`${action}Index`] = history[`${action}Index`] + this.actionStep;
      } else if (history[`${action}Index`] > history[action].length) {
        return false;
      }
      // change last modified element index
      key = history[`${action}Index`];
      if (key <= 0) {
        value = "";
      } else if (key > 0 && key < 16) {
        value = history[action][key];
      }
    } else {
      return false;
    }
    console.log(action);
    // get last action field name
    let ev = {
      target: {
        name: action,
        value: value
      }
    };

    this.setState(
      {
        [action]: value,
        history: history
      },
      () => this.handleCheck(ev)
    );
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState({
      slideshow: arrayMove(this.state.slideshow, oldIndex, newIndex)
    });
  };
  onSortMove = event => {
    event.preventDefault();
  };
  componentDidMount = () => {
    //

    let sliderSection = document.getElementsByClassName("sliderSection")[0];
    sliderSection.addEventListener("click", this.focusAddSlide);
    let dragArea = [
      document.getElementsByClassName("labelUploadlogo")[0],
      document.getElementsByClassName("labelUploadproductPhoto1")[0],
      document.getElementsByClassName("addItem")[0]
    ];

    dragArea.map((item, index) => {
      // get the last class name
      let list = item.classList;
      let dragAreaClass = list[list.length - 1];
      dragArea[index].addEventListener("dragenter", this.dragenter, false);
      dragArea[index].addEventListener("dragleave", this.dragleave, false);
      dragArea[index].addEventListener("dragover", this.dragover, false);
      if (dragAreaClass === "addItem") {
        dragArea[index].addEventListener("drop", this.addSlideItem, false);
      } else {
        dragArea[index].addEventListener("drop", this.handleOnchange, false);
      }
    });
  };

  componentWillUnmount = () => {
    document
      .getElementById("undo")
      .removeEventListener("click", this.handleUndo);
    document
      .getElementById("redo")
      .removeEventListener("click", this.handleRedo);
  };

  dragenter = e => {
    e.stopPropagation();
    e.preventDefault();
  };
  dragleave = e => {
    e.stopPropagation();
    e.preventDefault();
  };
  dragover = e => {
    e.stopPropagation();
    e.preventDefault();
  };

  dragInitializze = () => {
    this.dragAction("destroy");
    this.dragAction("constructor");
  };
  dragAction = action => {
    // let mv = document.getElementsByClassName("mv");
    let cl = document.getElementsByClassName("cl") || [];
    let rot = document.getElementsByClassName("rot");
    let cr = document.getElementsByClassName("cr");
    if (action == "constructor") {
      this.state.slideshow.map((i, index) => {
        cr[index].addEventListener("click", () =>
          this.handleEditor(this.state.slideshow[index], index)
        );
        rot[index].addEventListener("click", () =>
          this.handleEditor(this.state.slideshow[index], index)
        );
        cl[index].addEventListener("click", event =>
          this.removeSlideItem(event, index)
        );
      });
    }
    if (action == "destroy") {
      this.state.slideshow.map((i, index) => {
        cl[index].removeEventListener("click", event =>
          this.removeSlideItem(event, index)
        );
        cr[index].removeEventListener("click", () =>
          this.handleEditor(this.state.slideshow[index], index)
        );
        rot[index].removeEventListener("click", () =>
          this.handleEditor(this.state.slideshow[index], index)
        );
      });
    }
  };

  componentDidUpdate = () => {
    // check slideshow length to show/hide/style addslide item
    let addBlock = document.getElementsByClassName("addItem")[0];
    let sliderSection = document.getElementsByClassName("sliderSection")[0];
    let sliderUploadSection = document.getElementsByClassName(
      "slideshowUpload"
    )[0];
    if (this.state.slideshow.length) {
      addBlock.style.marginRight = "50px";
      sliderSection.removeEventListener("click", this.focusAddSlide);
    } else {
      addBlock.style.marginRight = "250px";
    }
    if (this.state.slideshow.length >= 6) {
      sliderUploadSection.style.width = "1200px";
      addBlock.style.display = "none";
    } else {
      addBlock.style.display = "flex";
      sliderUploadSection.style.width = "1300px";
    }
    if (this.state.logo) {
      window.localStorage.setItem("logo", this.state.logo);
      document.getElementsByClassName("labelUploadlogo")[0].style.display =
        "none";
      document.getElementsByClassName(
        "labelUploadlogo"
      )[0].style.backgroundColor = "transparent";
      document.getElementsByClassName(
        "labelUploadlogo"
      )[0].parentElement.style.height = "auto";
    } else {
      window.localStorage.removeItem("logo");
      document.getElementsByClassName("labelUploadlogo")[0].style.display =
        "block";
      document.getElementsByClassName(
        "labelUploadlogo"
      )[0].style.backgroundColor = "#f2f2f2";
      document.getElementsByClassName(
        "labelUploadlogo"
      )[0].parentElement.style.height = "64px";

      this.removeImageCache("logo_upload");
    }
    if (this.state.productPhoto1) {
      document.getElementsByClassName(
        "labelUploadproductPhoto1"
      )[0].style.display = "none";
      document.getElementsByClassName(
        "labelUploadproductPhoto1"
      )[0].style.backgroundColor = "transparent";
    } else {
      document.getElementsByClassName(
        "labelUploadproductPhoto1"
      )[0].style.display = "flex";
      document.getElementsByClassName(
        "labelUploadproductPhoto1"
      )[0].style.backgroundColor = "#f2f2f2";

      this.removeImageCache("productPhoto1_upload");
    }
    if (this.state.slideshow) {
      this.dragInitializze();
    }
  };

  // focus  on addslide block on slideshow part click
  focusAddSlide = () => {
    this.refs.slideshowUpload.scrollIntoView({ behavior: "smooth" });
  };
  handleChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState(
      {
        [name]: value
      },
      this.handleHistory(name, value)
    );
  };
  // modify history object
  handleHistory = (name, value) => {
    // create copy of history obbject for manipulation
    let history = this.state.history;
    if (history.lastModifiedElement.length > 15) {
      history = {
        // field history and current index
        logo: [null],
        logoIndex: 0,
        //
        productPhoto1: [null],
        productPhoto1Index: 0,
        //
        title: [null],
        titleIndex: 0,
        //
        attractiveText: [null],
        attractiveTextIndex: 0,
        //
        description: [null],
        descriptionIndex: 0,
        //
        buttonValue: [null],
        buttonValueIndex: 0,
        // last modified element
        lastModifiedElement: [null],
        lastModifiedElementIndex: 0
      };
    }

    // add value  to history array
    history[name].push(value);
    history[`${name}Index`] = history[`${name}Index`] + this.actionStep;
    // // reset last modified
    history.lastModifiedElement.push(name);
    history.lastModifiedElementIndex = history.lastModifiedElement.length - 1;
    this.setState({ history: history });
  };
  // check if enter pressed on textarea
  handleKeyPress = e => {
    let code = e.keyCode ? e.keyCode : e.which;
    if (code === 13) {
      e.target.blur();
    }
  };
  // empty textarea on focus
  handleOnFocus = event => {
    event.preventDefault();
    event.target.placeholder = "";
  };
  // check if textarea value equal to 0 return default value
  handleCheck = event => {
    let value = event.target.value;
    let name = event.target.name;
    if (value === 0 || value === "" || value === null) {
      document.getElementsByName(name)[0].placeholder = this.state[
        name + "Initial"
      ];
    }
  };
  // get image preview from input files
  handleOnchange = event => {
    event.stopPropagation();
    event.preventDefault();
    let file = event.target.files || event.dataTransfer.files;
    let fileSize = file[0].size / 1024;
    if (
      ((event.target && file.length != 0) ||
        (event.dataTransfer && file.length != 0)) &&
      fileSize < 500
    ) {
      let labelClass = event.target.closest("label");
      let str = labelClass.className;
      let stateName = str.substr(
        str.search("labelUpload") + "labelUpload".length,
        str.length
      );
      labelClass.style.display = "none";
      labelClass.parentElement.style.background = "transparent";
      if (str === "labelUploadlogo") {
        labelClass.parentElement.style.height = "auto";
        this.setState({ [stateName]: this.getUrlFromObj(file[0]) });
        window.localStorage.setItem("logo", this.getUrlFromObj(file[0]));
      } else {
        this.setState(
          { [stateName]: this.getUrlFromObj(file[0]) },
          this.handleEditor(this.getUrlFromObj(file[0]), stateName)
        );
      }
      this.handleHistory(stateName, this.getUrlFromObj(file[0]));
    } else if (fileSize > 500) {
      alert("invalid file size,recommended size 500kb  ");
    } else {
      return false;
    }
  };
  // remove uploaded images and return default classes
  removeUpload = eventItem => {
    let labelClassName = "labelUpload" + eventItem;
    let labelClass = document.getElementsByClassName(labelClassName)[0];
    labelClass.style.display = "block";
    labelClass.parentElement.style.background = "#f2f2f2";
    if (labelClassName === "labelUploadlogo") {
      labelClass.parentElement.style.height = "64px";
      window.localStorage.removeItem("logo");
    }
    this.setState(
      {
        [eventItem]: null
      },
      this.removeImageCache(eventItem + "_upload")
    );
  };
  // reset imagecache
  removeImageCache = img => {
    document.getElementById(img).value = "";
  };
  // slider images actions
  addSlideItem = event => {
    event.stopPropagation();
    event.preventDefault();
    let file = event.target.files || event.dataTransfer.files;
    let fileSize = file[0].size / 1024;
    if (
      ((event.target && file.length != 0) ||
        (event.dataTransfer && file.length != 0)) &&
      fileSize < 500
    ) {
      let uploadedFile = this.getUrlFromObj(file[0]);
      // event.preventDefault();
      this.setState(
        { slideshow: this.state.slideshow.concat([uploadedFile]) },
        this.handleEditor(uploadedFile, this.state.slideshow.length)
      );
      document.getElementById("slideshowitem_upload").value = "";
    } else if (fileSize > 500) {
      alert("invalid file size,recommended size 500kb  ");
    } else {
      return false;
    }
  };

  // chekc if save = curent step send request
  // check undo/redo
  componentWillReceiveProps = nextProps => {
    if (nextProps.save && nextProps.save === 1 && nextProps.show === 1)
      this.SendData();
    let action = nextProps.action;
    if (action) {
      this.actionUndo(action);
    }
  };
  // remove item from slideshow
  removeSlideItem = (event, key) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    let array = [...this.state.slideshow];
    array.splice(key, 1);
    this.setState({
      slideshow: array
    });
  };
  // save data
  SendData = e => {
    // e.preventDefault();
    let formData = new FormData();
    let slideshow = this.state.slideshow;
    formData.append(
      "image",
      // new File([this.state.logo], "logo", {
      //   type: "image/jpg",
      //   lastModified: Date.now()
      // })
      this.state.logo
    );
    formData.append(
      "image",
      new File([this.state.productPhoto1], "productPhoto", {
        type: "image/jpg",
        lastModified: Date.now()
      })
    );
    for (let item = 0; item < slideshow.length; item++) {
      let file = new File([slideshow[item]], "img" + item, {
        type: "image/jpg",
        lastModified: Date.now()
      });
      formData.append("image", file);
    }
    let data = JSON.stringify({
      title: this.state.title,
      attractiveText: this.state.attractiveText,
      shortDescription: this.state.description,
      buttonText: this.state.buttonValue
    });
    formData.append("sub", window.localStorage.getItem("subdomain"));
    formData.append("page", "homepage");
    formData.append("type", "page");
    formData.append("data", data);
    
// your request 
    
  };
  saveAlert = () => {
    setTimeout(
      () =>
        this.setState({
          saved: true
        }),
      0
    );
    setTimeout(
      () =>
        this.setState({
          saved: false
        }),
      1500
    );
  };

  // get bloob url from file
  getUrlFromObj = e => {
    let imagePreview;
    let binaryData = [];
    if (e) {
      binaryData.push(e);
      imagePreview = window.URL.createObjectURL(new Blob(binaryData));
      return imagePreview;
    }
    return;
  };

  // editor initiallize settings
  editorInitializze = () => {
    let cropper = this.refs.cropper;
    let image = this.refs.cropper.getImageData();
    cropper.setCanvasData({
      widtht: image.width,
      height: image.height
    });
    cropper.setCropBoxData({
      widtht: image.width,
      height: image.height
    });
  };
  // calls to open editor
  handleEditor = (img, key) => {
    this.setState({
      editorOpen: true,
      activeImg: img,
      activeImgKey: key
    });
    document.body.style.overflow = "hidden";
  };
  // cropper module actions
  editorAction = action => {
    let activeImage = this.refs.cropper;
    switch (true) {
      case action == "rotate":
        activeImage.rotate(90);
        break;
      case action == "crop":
        let canvas = activeImage.getCroppedCanvas({
          width: activeImage.getCropBoxData().width,
          heigh: activeImage.getCropBoxData().height,
          fillColor: "transparent"
        });
        activeImage.replace(canvas.toDataURL(), false);
        break;
      case action == "save" || action == "close":
        let canvasFinish = null;

        if (action == "save") {
          canvasFinish = activeImage.getCroppedCanvas({
            width: activeImage.getCropBoxData().width,
            heigh: activeImage.getCropBoxData().height
          });
        }
        if (action == "close") {
          activeImage.setCropBoxData({
            width: 600,
            left: 100
          });
          canvasFinish = activeImage.getCroppedCanvas({
            width: activeImage.getCropBoxData().width,
            heigh: activeImage.getCropBoxData().height
          });
        }
        let key = this.state.activeImgKey;
        if (canvasFinish) {
          if (key == "logo" || key == "productPhoto1") {
            this.setState({ [key]: canvasFinish.toDataURL() });
          } else if (key !== "logo" && key !== "productPhoto1") {
            let arrayNew = [...this.state.slideshow];
            arrayNew.splice(key, 1);
            arrayNew.push([canvasFinish.toDataURL()]);
            this.setState({ slideshow: arrayNew });
          }
          this.closeEditor();
        }
        break;
      case action == "undo":
        activeImage.replace(this.state.activeImg, false);
        break;
    }
  };
  // close editor view
  closeEditor = () => {
    this.setState({
      editorOpen: false,
      activeImg: null,
      activeImgKey: null
    });
    document.body.style.overflow = "auto";
  };

  render() {
    // remove uploaded image
    let showCloseButtonLogo,
      showCloseButtonProduct1,
      showCloseButtonProduct2 = false;
    this.state.logo
      ? (showCloseButtonLogo = true)
      : (showCloseButtonLogo = false);

    this.state.productPhoto1
      ? (showCloseButtonProduct1 = true)
      : (showCloseButtonProduct1 = false);

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      // autoplay:true,
      nextArrow: (
        <Ionicon
          icon="ios-arrow-dropright-circle"
          fontSize={40}
          color="#f9dd31"
        />
      ),
      prevArrow: (
        <Ionicon
          icon="ios-arrow-dropleft-circle"
          fontSize={40}
          color="#f9dd31"
        />
      )
    };
    let style;
    this.props.show
      ? (style = { display: "block" })
      : (style = { display: "none" });

    return (
      <div className="regStep step1" style={style}>
        <div className="row">
          <div className="imageUpload uploadLogo">
            {showCloseButtonLogo && (
              <Ionicon
                icon="ios-close-circle"
                fontSize={30}
                className="removeIcon"
                color="#f9dd31"
                onClick={() => this.removeUpload("logo")}
              />
            )}
            <label
              htmlFor="logo_upload"
              id="labelUpload"
              className="labelUploadlogo"
            >
              <div className="parentSection">
                <div className="perfectCenter">
                  <Ionicon icon="md-camera" fontSize="48px" color="#bdc3c7" />
                </div>
                <div className="perfectCenter">
                  <p className="logoBigText">YOUR LOGO</p>
                  <p className="logoSmallText">
                    Drag{` & `}Drop or Click to upload
                  </p>
                </div>
              </div>
              <input
                type="file"
                onChange={this.handleOnchange}
                id="logo_upload"
                name="logo"
                accept="image/*"
              />
            </label>

            {this.state.logo ? <img src={this.state.logo} /> : null}
          </div>
        </div>
        <div className="sectionUpload">
          <div className="rowL">
            <div className="columnLeft perfectCenter">
              {showCloseButtonProduct1 && (
                <Ionicon
                  icon="ios-close-circle"
                  fontSize={30}
                  className="removeIcon"
                  color="#f9dd31"
                  onClick={() => this.removeUpload("productPhoto1")}
                />
              )}
              <label
                htmlFor="productPhoto1_upload"
                className="labelUploadproductPhoto1"
              >
                <div className="parentSection">
                  <div className="perfectCenter">
                    <Ionicon icon="md-camera" fontSize="74px" color="#c8c8c8" />
                  </div>
                  <div className="perfectCenter">
                    <p className="big">
                      DRAG {`&`} DROP OR CLICK HERE
                      <br />
                      TO UPLOAD
                      <br />
                      THE BEST PHOTO OF YOUR PRODUCT
                    </p>
                    <p className="small">
                      recommended size ↔ 600 x ↕ 560px
                      <br />
                      max 500 kb
                    </p>
                  </div>
                </div>
                <input
                  type="file"
                  onChange={this.handleOnchange}
                  id="productPhoto1_upload"
                  name="productPhoto1"
                  accept="image/*"
                />
              </label>
              {this.state.productPhoto1 ? (
                <img
                  src={this.state.productPhoto1}
                  onClick={() =>
                    this.handleEditor(this.state.productPhoto1, "productPhoto1")
                  }
                />
              ) : null}
            </div>
            <div className="columnRight perfectCenter ">
              <label className="labelforHover">
                <textarea
                  tabIndex="1"
                  spellcheck="false"
                  value={this.state.title}
                  placeholder={this.state.titleInitial}
                  onChange={this.handleChange}
                  onFocus={this.handleOnFocus}
                  onBlur={this.handleCheck}
                  className="titleTextarea"
                  name="title"
                  rows="3"
                  maxLength="30"
                />
                {edit(40)}
              </label>
            </div>
          </div>
          <div className="rowL ">
            <div className="columnLeft perfectCenter desc">
              <label className="labelforHover">
                <textarea
                  tabIndex="2"
                  spellcheck="false"
                  value={this.state.attractiveText}
                  placeholder={this.state.attractiveTextInitial}
                  onChange={this.handleChange}
                  // onClick={this.handleOnFocus}
                  onFocus={this.handleOnFocus}
                  onBlur={this.handleCheck}
                  className="heading"
                  name="attractiveText"
                  rows="2"
                  maxLength="25"
                />
                {edit(40)}
              </label>
              <label className="labelforHover">
                <textarea
                  tabIndex="3"
                  spellcheck="false"
                  value={this.state.description}
                  placeholder={this.state.descriptionInitial}
                  onChange={this.handleChange}
                  // onClick={this.handleOnFocus}
                  onBlur={this.handleCheck}
                  onFocus={this.handleOnFocus}
                  className="description "
                  name="description"
                  maxLength="150"
                />
                {edit(40)}
              </label>
              <div className="letfAlign">
                <button className=" yButton ">
                  <label className="labelforHover">
                    <textarea
                      tabIndex="4"
                      spellcheck="false"
                      value={this.state.buttonValue}
                      placeholder={this.state.buttonValueInitial}
                      onChange={this.handleChange}
                      onFocus={this.handleOnFocus}
                      // onClick={this.handleOnFocus}
                      onKeyPress={this.handleKeyPress}
                      onBlur={this.handleCheck}
                      className="buttonArea"
                      name="buttonValue"
                      rows="1"
                      maxLength="10"
                    />
                    {edit(30)}
                  </label>
                </button>
              </div>
            </div>
            <div className="columnRight sliderSection">
              <Slider {...settings}>
                {this.state.slideshow.length == 0 ? (
                  <div className="perfectCenter ">
                    <p className="big">
                      ADD 1 TO 6 IMAGES FROM THE BOX BELOW
                      <br />
                      TO APPEAR HERE AS A SLIDESHOW
                    </p>
                    <p className="small">
                      recommended size ↔ 600 x ↕ 560px
                      <br />
                      max 500 kb
                    </p>
                    <Ionicon
                      icon="ios-arrow-round-down"
                      fontSize="74px"
                      color="#bdc3c7"
                      className="alternateIcon"
                    />
                  </div>
                ) : null}
                {this.state.slideshow.map((item, key) => (
                  <div className="parentSection perfectCenter" key={key}>
                    <img src={item} />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
        <div className="slideshowUpload" ref="slideshowUpload">
          <div className="slideshowItem perfectCenter addItem">
            <label
              htmlFor="slideshowitem_upload"
              id="slideShowLabel"
              className="labelUploadslideshowItem"
            >
              <Ionicon icon="md-camera" fontSize="44px" color="#c8c8c8" />
              <div>
                <p className="addItemBigText">
                  DRAG {`&`} DROP OR CLICK HERE
                  <br />
                  TO UPLOAD
                  <br />
                  PHOTO OF YOUR PRODUCT `
                </p>

                <p className="logoSmallText">
                  ↔ 600 x ↕ 560px <br /> max 500 kb
                </p>
              </div>
              <input
                type="file"
                onChange={this.addSlideItem}
                id="slideshowitem_upload"
                name="slideshowItem"
                accept="image/*"
              />
            </label>
          </div>
          <SortableList
            pressDelay={0}
            useDragHandle={true}
            // disabled={true}
            helperClass="sort"
            transitionDuration={100}
            axis="x"
            lockAxis="x"
            items={this.state.slideshow}
            onSortEnd={this.onSortEnd}
            onSortMove={this.onSortMove}
          />
        </div>

        {this.state.editorOpen && (
          <div className="overlayEditor">
            <Cropper
              ref="cropper"
              src={this.state.activeImg}
              className="editorBody"
              // Cropper.js options
              autoCrop={true}
              aspectRatio={1.071}
              background={false}
              guides={false}
              ready={this.editorInitializze}
              center={true}
              zoomable={false}
            />
            <div className="editorTools perfectCenter">
              <Ionicon
                icon="ios-undo"
                className="editorButton"
                fontSize="40px"
                color="white"
                onClick={() => this.editorAction("undo")}
              />
              <Ionicon
                icon="ios-crop-outline"
                className="editorButton"
                fontSize="50px"
                color="white"
                onClick={() => this.editorAction("crop")}
              />
              <Ionicon
                icon="ios-refresh"
                className="editorButton"
                fontSize="50px"
                color="white"
                onClick={() => this.editorAction("rotate")}
              />
              <div className="editorButtonGroup">
                <Ionicon
                  icon="ios-checkmark"
                  className="editorButton"
                  fontSize="60px"
                  color="white"
                  onClick={() => this.editorAction("save")}
                />
                <Ionicon
                  icon="ios-close"
                  className="editorButton"
                  fontSize="60px"
                  color="white"
                  onClick={() => this.editorAction("close")}
                />
              </div>
            </div>
          </div>
        )}

        <span
          onClick={() => {
            this.props.step("forward");
          }}
        >
          {NavigationArrow("next")}
        </span>

        <div className="footer" />
        {this.state.saved && Saved}
      </div>
    );
  }
}
